const axios = require('axios')
const config = require('../config/index')

let getDataAsync = async (filename) => {
  let uri = `${config.SeriesData}${filename}`

  try {
    //console.log('[getSerieses.js]', 'getDataAsync', filename, status.isFetching)
    const { data } = await axios.get(uri)

    return data
  }
  catch (ex) {
    console.log('[get-serieses.js]', 'getDataAsync', filename, ex)

    throw (ex)
  }

}

const getSeriesesJsonList = function () {
  //console.log('getSeriesesJsonList loading...')

  // return [
  //   "_state-series1.json",
  //   "_state-series2.json",
  //   "_state-series3.json",
  //   "_state-series4.json",
  //   "_state-series5.json",
  //   "_state-series6.json",
  // ];

  return new Promise(async function (resolve, reject) {
    try {
      let data = await getDataAsync('serieses.json')

      resolve(data)
    }
    catch (ex) {
      reject({
        error: true,
        ex
      })
    }
  })
};

export { getSeriesesJsonList }



// WEBPACK FOOTER //
// ./src/series-data/get-serieses.js